import { instanceBo as axios } from "../utils/axios.create";
import { RoleItem } from "../domain/rol.interface";
import { IRole } from "../domain/role.interface";

export interface RoleRequest {
	code: string;
	name: string;
	actions: string[];
	ouLevel?: string;
	status: string;
	type: string;
	createdBy: string;
}

export interface RoleUpdateRequest extends Omit<RoleRequest, "createdBy"> {
	_id: string;
	updatedBy: string;
}

export interface RolesResponse {
	statusCode: number;
	body: IRole[];
}

const findActiveRolesByAccountId = async (): Promise<
	{ id: string; name: string; type: string; level: number }[]
> => {
	return axios
		.get("/roles")
		.then((res) => {
			const roles = res.data.body as RoleItem[];
			return roles
				.filter((rol: RoleItem) => rol.status.toUpperCase() === "ACTIVE") // Filter only active roles
				.map((rol: RoleItem) => {
					return {
						id: rol.id,
						name: rol.name,
						type: rol.type,
						level: rol.level,
					};
				});
		})
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

export const getRoles = async (search?: string): Promise<RolesResponse> => {
	const params = new URLSearchParams();
	if (search) params.append("search", search);

	const queryString = params.toString();
	const url = `/roles${queryString ? `?${queryString}` : ""}`;

	return axios
		.get(url)
		.then((res) => res.data)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const createRole = async (roleData: RoleRequest): Promise<IRole> => {
	return axios
		.post("/roles", roleData)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const updateRole = async (
	roleData: RoleUpdateRequest,
): Promise<IRole> => {
	const { _id, ...updateData } = roleData;
	return axios
		.put(`/roles/${_id}`, updateData)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const deleteRole = async (roleId: string): Promise<void> => {
	return axios
		.delete(`/roles/${roleId}`)
		.then(() => undefined)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const rolService = {
	findActiveRolesByAccountId,
};
